<template>
  <div
    class="lod-fallback bg-node-component-widget-skeleton-surface absolute inset-0 size-full"
  ></div>
</template>
